<template>
  <v-card fill-height>
  <div class="becci">
   <!-- <BtnDownloadExcel :balance="balance" :configExcel="configExcel"></BtnDownloadExcel>-->
    <DialogKonfigurationRows ref="DialogKonfigurationRows" :structureData="tableData" @close="reloadConfig" @currentConfigName="updateCurrentConfigName"></DialogKonfigurationRows>
    <v-tabs
      color="white"
      light
      name="sbTabPanel"
      v-model="tab2"
      ref="myTab"
      slider-color="#8ACAC1"
      @change="onChangeTab"
      class="activetab"
    >
      <v-tab name="tabAktiva" href="#tabAktiva">{{'TAB_STRUKTURBILANZ_AKTIVA' | translate}}</v-tab>
      <v-tab name="tabPASSIVA" href="#tabPASSIVA">{{'TAB_STRUKTURBILANZ_PASSIVA' | translate}}</v-tab>
      <v-tab name="tabGUV" href="#tabGUV">{{'TAB_STRUKTURBILANZ_GUV' | translate}}</v-tab>
      <v-tab name="tabAUX" href="#tabAUX">{{'TAB_STRUKTURBILANZ_SONSTIGE' | translate}}</v-tab>
      <v-spacer></v-spacer>
      <template>
            <SelectConfigurationList name="tsb" ref="cList" v-if="showSelect" @change="reload"></SelectConfigurationList>
            <v-icon @click="reload" color="#004884" class="handpointer">refresh</v-icon>
            <v-btn @click="openDialog" class="text-none" color="#004884" small outline>{{'BTN_KONFIGURATION'| translate}}</v-btn>
      </template>
      <v-tab-item active value="tabAktiva" name="tabAktiva">
        <StrukturBilanzTable levelST="_ST" configSuffix="SB" :sortDisabled="true" :heightSub="tableHeightSub" :widthSub="40" ref="tabAktiva" tableName="aktiva" edoClassName="sb" :RowBKGFromSource="true"></StrukturBilanzTable>
      </v-tab-item>
      <v-tab-item value="tabPASSIVA" name="tabPASSIVA">
        <StrukturBilanzTable levelST="_ST" configSuffix="SB" :sortDisabled="true" :heightSub="tableHeightSub" :widthSub="40" ref="tabPASSIVA" tableName="passiva" edoClassName="sb" :RowBKGFromSource="true"></StrukturBilanzTable>
      </v-tab-item>
      <v-tab-item value="tabGUV" name="tabGUV">
        <StrukturBilanzTable levelST="_ST" configSuffix="SB" :sortDisabled="true" :heightSub="tableHeightSub" :widthSub="40" ref="tabGUV" tableName="guv" edoClassName="sb" :RowBKGFromSource="true"></StrukturBilanzTable>
      </v-tab-item>
      <v-tab-item value="tabAUX" name="tabAUX">
        <StrukturBilanzTable levelST="_ST" configSuffix="SB" :sortDisabled="true" :heightSub="tableHeightSub" :widthSub="40" ref="tabAUX" tableName="aux" edoClassName="sb" :RowBKGFromSource="true"></StrukturBilanzTable>
      </v-tab-item>
    </v-tabs>
  </div>
  </v-card>
</template>

<script>
import Vue from 'vue'
import StrukturBilanzTable from './StrukturBilanzTable'
import SelectConfigurationList from './../../widgets/SelectConfigurationList'
import DialogKonfigurationRows from './../dialogs/DialogKonfigurationRows'
import BtnDownloadExcel from './../../widgets/BtnDownloadExcel'
export default {
  name: 'TabStrukturBilanz',
  components: {StrukturBilanzTable, SelectConfigurationList, DialogKonfigurationRows, BtnDownloadExcel},
  props: ['balance','isPeergroup', 'balanceArray'],
  methods: {
    updateCurrentConfigName (cName) {
      if (cName) {
        if (this.$refs.cList) {
          this.$refs.cList.updateConfigNameFromDialog(cName)
        }
      }
    },
    reloadConfig() {
      let cmp = this
      console.log('reloadConfig')
      if (this.$refs.cList) {
        this.$refs.cList.reload({
          rk: cmp.tableData.commonRkNr,
          guvNr: cmp.tableData.commonGuvNr
        })
      }
    },
    close: function () {
      if (this.lastTab) {
        var item = this.lastTab
        if (this.$refs[item] && this.$refs[item].close) {
          Vue.prototype.$api.debug('close', item)
          this.$refs[item].close()
        }
      }
    },

    onChangeTab (item) {
      Vue.prototype.$api.debug('onChangeTab', item, this.lastTab)
      if (this.lastTab) {
        if (this.$refs[item] && this.$refs[item].close) {
          Vue.prototype.$api.debug('close', item)
          this.$refs[item].close()
        }
      }
      if (this.$refs[item] && this.$refs[item].open) {
        Vue.prototype.$api.debug('open', item)
        this.$refs[item].open(this.tableData)
      }
      this.lastTab = item
    },

    open: function (data) {
      Vue.prototype.$eventHub.$emit('OnGetExcelConfig', this.configExcel)
      // this.tableData = _.clone(data)
      if (!this.lastTab) {
        this.lastTab = 'tabAktiva'
      }
      this.reload()
    },
    onGetData: function (data) {
      Vue.prototype.$api.debug('onGetData', data)
      this.tableData = data; //_.clone(data)
      var cmp = this
      Vue.prototype.$api.hideIdle()
      this.$refs[this.lastTab].close()
      this.$refs[this.lastTab].open(this.tableData)
      // this.$refs[this.lastTab].update(this.tableData)

      this.$nextTick(() => {
        cmp.$refs[cmp.lastTab].open(cmp.tableData)
        /*
        $('div[name=sbTabPanel]').find('a').css('position', 'static')
        $('div[name=sbTabPanel]').find('a').addClass('v-tabs__item--active')
        $('div[name=sbTabPanel]').find('.v-tabs__slider-wrapper').css('width', 70)

         */

        if (cmp.$refs.cList) {
          cmp.$refs.cList.reload({
            rk: data.commonRkNr,
            guvNr: data.commonGuvNr
          })
        } else {
          console.error('mussing clist')
        }
      })

    },
    openDialog () {
      this.$refs.DialogKonfigurationRows.show(this.data)
    },
    reload: function (configName) {
      this.configName = Vue.prototype.storage.getConfigName()
      Vue.prototype.$api.debug('reload', configName, this.balance, this.$refs.myTab, this.balanceArray, this.isPeergroup)
      Vue.prototype.$api.showIdle()
      if (this.isPeergroup) {
        Vue.prototype.$api.createStructureDataWithBalanceArray(this.balanceArray, this.configName, this.onGetData)
      } else {
        Vue.prototype.$api.createStructureDataWithBalance(this.balance, this.configName, this.onGetData)
      }
    }
  },
  data () {
    return {
      tableHeightSub: 160,
      configName: '',
      configExcel: {
        excelSheetStammdaten: 0,
        excelSheetStrukturbilanz: 1,
        excelSheetRohbilanz: 0,
        excelSheetKennzahlen: 0,
        excelSheetBilanzrating: 0,
        excelSheetKDF: 0,
        btnName: Vue.i18n.translate('DOWNLOAD_NAME_SB'),
        configName: '',
        type: 'EXCEL-STRUCT'
      },
      lastTab: 'tabAktiva',
      showSelect: true,
      keyIndex: 0,
      tableData: null,
      tab2: 'tabAktiva'
    }
  },
  mounted () {
    var cmp = this
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/module/akte/TabStrukturBilanz.vue